import { createGlobalStyle } from "styled-components";

import bgStepTopImage from "./assets/bg-step-top.jpg";
import bgStepBottomImage from "./assets/bg-step-bottom.jpg";

const phoneMixin = `@media all and (max-width: 768px)`;
const tabletMixin = `@media all and (min-width: 769px)`;
//const desktopMixin = `@media all and (min-width: 1024px)`;

export const GlobalStyle = createGlobalStyle`
    :root {
        --fontFamily: "Helvetica Neue", Helvetica, Arial, sans-serif;
        --white: #ffffff;
        --whiteMedium: #f3f3f3;
        --whiteDark: #f5f5f5;
        --black: #000000;
        --grayBlack: #2f2e2e;
        --grayDark: #494a4b;


        --borderGray: #acacac;
        --borderGrayLight: #dbdbdb;


        --tableRow: #f3f3f3;
        --tableRowOdd: #fbf9f9;

        /*  v3 Colors  */
        --blueLight: #3aaae7;
        --blue: #00617f;
        --blueDark: #10384f;
        --gray: #6b6e6d;
        --grayLight: #d2d2d2;
        --greenDark: #004422;
        --green: #2b6636;
        --greenLight: #66b512;
        --red: #d30f4b;
    }

    *, *::before, *::after {
        box-sizing: border-box;
    }

    ::placeholder {
        color: #c2c2c2;
    }

    html, body, p, ol, ul, li, dl, dt, dd, blockquote, figure, fieldset, legend, textarea, pre, iframe, hr, h1, h2, h3, h4, h5, h6, hr, div, table, input {
        margin: 0;
        padding: 0;
    }

    img, audio, video {
        height: auto;
        max-width: 100%;
    }

    img {
        display: block;
    }

    #content {
        width: 100%;
    }
    #app {
        max-width: 906px;
        margin: 0 auto;
    }

    #precontent img, #content img {
        max-width: 100%;
        max-height: 100%;
        height: auto;
    }

    a {
        text-decoration: none;
    }

    p,
    .p,
    .branches,
    .plaintext {
        line-height: 1.5;
    }

    .plaintext p {
        margin-bottom: 20px;
    }

    .control {
        font-size: 1rem;
        position: relative;
        text-align: left;
    }

    .is-clearfix::after {
        clear: both;
        content: " ";
        display: table;
    }

    .input, .taginput .taginput-container.is-focusable, .textarea {
        background-color: white;
        border-color: #dbdbdb;
        color: #363636;
        -webkit-box-shadow: inset 0 1px 2px rgb(10 10 10 / 10%);
        box-shadow: inset 0 1px 2px rgb(10 10 10 / 10%);
        max-width: 100%;
        width: 100%;
        border-radius: 0;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }

    /* Firefox */
    input[type=number] {
    -moz-appearance: textfield;
    }

    /* Fonts */
    body,
    button,
    input,
    select,
    textarea {
        font-family: var(--fontFamily);
        color: var(--blueDark);
    }


    /* Headings */
    h1 {
        font-size: 1.75rem;
        line-height: 1.14;
        font-weight: bold;
        margin-bottom: 1rem;
        &.app-heading {
            margin: 0 0 2rem;
            ${phoneMixin} {
                margin: 0 1.25rem 2rem;
            }
        }
    }

    h2 {
        font-size: 1rem !important;
        color: var(--blueDark) !important;
        font-weight: bold;
        margin-bottom: 1rem;
    }

    h3.subheading {
        color: var(--blueDark) !important;
        font-size: .875rem !important;
        font-style: italic;
        margin: -1rem 0 1rem;
    }


    /* Colors */
    .text-white {
        color: var(--white);
    }

    .text-green {
        color: var(--green);
    }


    /* Copy */
    .copy {
        color: var(--grayBlack);
        font-size: 1rem;
        text-align: left;
        &.padded {
            padding: 25px 10px;
        }
        ${tabletMixin} {
            font-size: 20px;
            &.padded {
                padding: 25px;
            }
            &.thin {
                font-size: 16px;
            }
        }
        &.clamped {
            ${tabletMixin} {
                width: 80%;
            }
        }
    }

    .title,
    .subtitle {
        color: $black;
        font-weight: bold;
    }

    .title {
        &.is-1 {
            font-size: 2rem;
            ${tabletMixin} {
                font-size: 3rem;
            }
        }
        &.is-2 {
            font-size: 1.35rem;
            ${tabletMixin} {
                font-size: 2.5rem;
                &.medium {
                    font-size: 32px;
                }
                &.thin {
                    font-size: 26px;
                }
            }
        }
    }

    .text-bold {
        font-weight: bold;
    }

    .text-center {
        text-align: center;
        .label.mobile {
            text-align: left;
        }
    }

    .text-note {
        font-size: 12px;
    }

    /* Buttons */
    a.button, button.button  {
        display: inline-block;
        background-color: var(--greenDark);
        border-radius: 0;
        border: none;
        color: var(--white)!important;
        font-size: 1rem;
        font-weight: bold;
        text-transform: none;
        width: auto;
        padding: .5rem 1.25rem;
        height: auto;
        cursor: pointer;
        outline: none;
        transition: all .125s ease-in-out;
        white-space: normal;
        text-decoration: none;
        line-height: 1.5;
        text-align: center;
        box-sizing: border-box;

        &:hover {
            background-color: var(--green);
            color: var(--white);
        }

        &.is-primary {
            background-color: var(--blueDark);
            &:hover {
                background-color: var(--blue);
            }
            &:disabled {
                cursor: none;
                pointer-events: none;
                background-color: var(--blue);
            }
        }

        ${phoneMixin} {
            display: block;
        }
    }

    .button {
        &.radio {
            text-transform: none;
        }
    }

    .add-button {
        background: transparent;
        border: none;
        color: var(--blue) !important;
        cursor: pointer;
        font-size: .875rem;
        font-weight: bold;
        line-height: 25px;
        margin: 0;
        outline: none;
        padding: 0;
        .icon {
            color: var(--greenLight);
            vertical-align: top;
            font-size: 24px;
        }
    }

    .remove-button {
        text-align: right;
        padding-bottom: 0!important;
        button {
            align-items: center;
            background: transparent;
            border: none;
            color: var(--blue) !important;
            cursor: pointer;
            display: inline-flex;
            font-size: 1rem;
            font-weight: bold !important;
            margin: 0;
            padding: 0;
            outline: none;
            transition: opacity .125s ease-in-out;
            

            ${tabletMixin} {
                height: 36px;
            }
            .icon {
                color: var(--red);
                margin-left: 1rem;
                font-size: 24px;

                ${tabletMixin} {
                    opacity: .50;
                }
            }

        }
    }
    .edit_button {
        text-align: right;
        text-decoration: underline;
    }
    .clear-button {
        text-align: right;
        margin: -1rem 2rem 2rem;
        button {
            background: transparent;
            border: none;
            color: var(--red) !important;
            cursor: pointer;
            font-size: 1rem;
            margin: 0;
            outline: none;
            padding: 0;
            text-transform: uppercase;
            transition: opacity .125s ease-in-out;

            ${tabletMixin} {
                opacity: .5;

                &:hover, &:focus {
                    cursor: pointer;
                    color: var(--red);
                    opacity: 1;
                }
            }
        }
    }

    .table-columns {
        &:hover, &:focus {
            .remove-button .icon {
            opacity: 1;
            }
        }
    }

    .actions {
        justify-content: flex-end;

        &button {
            background-color: var(--red);
            border: none;
            color: var(--white);
            cursor: pointer;
            height: 42px;
            outline: none;
            text-transform: uppercase;
            min-width: 100px;
            font-size: 16px;
            font-weight: 600;
            margin-right: 10px;
            padding-top: 5px;
            text-align: left;
            vertical-align: middle;
        }

        .icon {
            margin-right: 10px;

            .mdi-36px {
                &:before {
                    font-size: 24px !important;
                    vertical-align: middle;
                }
            }
        }

        ${tabletMixin} {
            min-width: 190px;
        }

        &.final .button {
            ${tabletMixin} {
            margin-left: .5rem;
            }
        }
    }

    .back-link-mobile {
        display: inline-block;
        margin: 0 0 .375rem 2rem;
        padding: 0 .5rem .5rem 0;
        color: var(--blue) !important;
        font-size: .75rem;
        font-weight: bold;
        &:before {
            content: "« "
        }

        ${tabletMixin} {
            display: none;
        }

    }

    .back-link {
        color: var(--greenDark) !important;
        display: block;
        text-align: center;
        font-size: .875rem;
        font-weight: bold;
        &:before {
            content: "« "
        }
    }

    /* Sections */
    .step-wrapper {
        margin: 0;
        width: 100%;
        padding: 1px 0 1px; // contain child margins
        background-image: url(${bgStepTopImage}), url(${bgStepBottomImage});
        background-position: left top, left bottom;
        background-size: contain;
        background-repeat: no-repeat;

        ${phoneMixin} {
            padding-bottom: 6rem !important; 
        }
    }


    /* Boxes */
    .boxed {
        &.padded {
            padding: 25px;
            &.thin {
                padding: 15px 25px;
            }
        }
        .box-item {
            align-items: center;
            display: flex;
            &.padded {
                padding: 25px;
            }
            &.thin {
                padding: 15px 25px;
            }
            .copy {
                padding: 0;
            }
            h4 {
                font-size: 1.25rem;
                line-height: 1.2em;
            }
        }
    }


    /* Flex */
    .flexed {
        display: flex;
        flex-direction: column;
        &.flex-columns {
            flex-direction: column;
        }
        &.flex-row {
            flex-direction: row;
        }
        ${tabletMixin} {
            flex-direction: row;
        }
    }


    /* Forms */
    .select select:focus,
    .select select.is-focused,
    .select select:active,
    .select select.is-active,
    .input:focus {
        border-color: var(--greenLight) !important;
        box-shadow: none;
        outline: none;
    }

    .select,
    .select select {
        width: 100%;
        &.thin {
            margin-bottom: 0 !important;
        }
    }

    .select:not(.is-multiple):not(.is-loading)::after, .navbar-link::after {
        border: 3px solid transparent;
        border-radius: 2px;
        border-right: 0;
        border-top: 0;
        content: " ";
        display: block;
        height: 0.625em;
        margin-top: -0.4375em;
        pointer-events: none;
        position: absolute;
        top: 50%;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        -webkit-transform-origin: center;
        transform-origin: center;
        width: 0.625em;
    }

    .select:not(.is-multiple):not(.is-loading)::after {
        border-color: #7957d5;
        right: 1.125em;
        z-index: 4;
    }

    .select:not(.is-multiple):not(.is-loading)::after {
        border-color: #d2d2d2;
    }

    .select:not(.is-multiple):not(.is-loading)::after {
        border-width: 4px;
        border-color: #494a4b;
    }

    .select select,
    .input {
        border-radius: 0;
        border: var(--grayLight) 2px solid !important;
        transition: all .125s ease-in-out !important;
        background-color: var(--white) !important;
        line-height: 1.5;
    }

    .select:not(.is-multiple):not(.is-loading)::after {
        border-color: var(--grayLight);
    }

    .input {
        box-shadow: none;
    }

    .textarea {
        border: var(--grayLight) 2px solid;
        border-radius: 0;
        box-shadow: none;
        color: var(--blueDark);
        &:focus {
            border-color: var(--greenLight) !important;
            box-shadow: none;
        }
    }

    .field {
        position: relative;
        .help {
            position: absolute;
            bottom: -1.25rem;
        }
        .input {
            +.icon {
                display: none;
            }
        }

        &.has-addons {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: start;
            -ms-flex-pack: start;
            justify-content: flex-start;
        }
    }

    .select:not(.is-multiple):not(.is-loading)::after {
        border-width: 4px;
        border-color: var(--grayDark);
    }

    .has-error {
        .input {
            &:required {
                border-color: var(--red);
            }
        }
    }

    .mt-30 {
        margin-top: 30px;
    }

    .mt-10 {
        margin-top: 10px;
    }

    .module-email {
        .title {
            margin-bottom: 0;
        }
        .app-copy {
            &:first-child {
                padding-bottom: 5px;
            }
        }
    }


    /* Tables */
    .table-wrapper {
        &.disabled {
            pointer-events: none;
            opacity: .5;
        }
        .thead {
            display: none;
            color: var(--blue);
            font-size: .875rem;
            font-style: italic;
            ${tabletMixin} {
                display: block;
            }
            .tr {
                align-items: flex-end;
                .th {
                    padding: 0 1rem 0.125rem 0;
                    &:first-child {
                        ${tabletMixin} {
                            text-align: left;
                        }
                    }
                }
            }
        }
        .tbody {
            .tr {
                .td {
                    padding: 0 1rem 1rem 0;
                    flex: 1;
                    ${tabletMixin} {
                        padding: 0 1rem 1rem 0;
                    }
                    .cell {
                        display: flex;
                        justify-content: center;
                        height: 100%;
                        &.half {
                            height: 50%;
                        }
                        &.middle {
                            align-items: center;
                        }
                        &.bottom {
                            align-items: flex-end;
                        }
                    }
                }
            }
        }
        .table-columns {
            display: flex;
            flex-wrap: wrap;
            .table-column {
                display: block;
                flex-basis: 0;
                flex-grow: 1;
                flex-shrink: 1;
                padding: 0.75rem;
                ${phoneMixin} {
                    &.mobile-width-100 {
                        flex: 0 0 100% !important;
                    }
                    &.mobile-width-40 {
                        flex: 0 0 40% !important;
                    }
                }
            }
            ${phoneMixin} {
                padding: 1rem 0 .5rem 1rem;
                border: 1px solid rgba(81, 187, 252, .25);
                margin-bottom: 1rem;
            }
        }
        .tr {
            .th,
            .td {
                flex: 1 1 auto;
                &:first-child {
                    ${tabletMixin} {
                        flex: 2 0 25%;
                    }
                    &.th--step-5, &.td--step-5 {
                        ${tabletMixin} {
                            flex: 2 0 9%;
                        }
                    }
                }
                &:nth-child(2) {
                    .field.has-addons {
                        input {
                            /*line-height: 12px;*/
                            line-height: 1.5;
                        }
                    }
                    ${tabletMixin} {
                        flex: 1 0 5rem;
                    }
                    &.th--step-5, &.td--step-5 {
                        ${tabletMixin} {
                            flex: 2 0 3%;
                        }
                    }
                }
                &:nth-child(3){
                    flex: 0 1 8rem;

                    &.th--step-5, &.td--step-5 {
                        ${tabletMixin} {
                            flex: 2 0 4%;
                        }
                    }
                }

                &:nth-child(4) {
                    flex: 0 1 8rem;

                    &.th--step-5, &.td--step-5 {
                        ${tabletMixin} {
                            flex: 2 0 11%;
                        }
                    }
                }
                &:nth-child(5) {
                    flex: 0 1 3rem;
                    ${tabletMixin} {
                        text-align: center;
                    }

                    &.th--step-5, &.td--step-5 {
                        ${tabletMixin} {
                            flex: 2 0 5%;
                        }
                    }
                }
            }
            &.readonly .td {
                p {
                    padding-top: 10px;
                }
                font-weight: 500;
            }
            span {
                line-height: 36px;
            }

            .td .cta--other-seed {
                font-style: italic;
                font-size: 13px;
            }
        }
        .label {
            display: block;
            padding-bottom: 0.5em;
            margin: 0;
            text-decoration: underline;
            &.simple {
                text-decoration: none;
                padding: 0;
            }
            &.mobile {
                ${tabletMixin} {
                    display: none;
                }
            }
        }
    }

    .w-50p {
        width: 50px;
    }

    .mobile {
        ${tabletMixin} {
            display: none;
        }
    }


    /* v3 styles */
    .d-block {
        display: block;
    }

    .subsection {
        margin: 0 2rem 2rem;
        padding: 2rem;
        border-top: 2px solid transparent;
        border-bottom: 2px solid transparent;
        ${phoneMixin} {
            margin: 0 1rem 2rem;
            padding: 2rem 1rem;
        }
        &.green-theme, &.dark-blue-theme, &.red-theme  {
            background: linear-gradient(#f3f9e9, #ffffff);
            .divider {
                border-width: 0;
                margin: 2rem 0;
                height: 1px;
                background-color: var(--greenLight);
                &:after {
                    content: "+";
                    display: block;
                    color: var(--greenLight);
                    line-height: 3px;
                    font-size: 30px;
                    position: relative;
                    font-weight: 900;
                    top: -2px;
                    left: 35px;
                    width: 35px;
                }
            }

            .divider--no-plus {
                &:after {
                    content: "";
                }
            }
        }

        &.green-theme {
            border-color: var(--greenLight);
        }

        &.dark-blue-theme {
            border-color: var(--blueDark);
        }

        &.red-theme {
            border-color: var(--red);
            border-bottom: none;
        }

        &.blue-theme {
            border-color: var(--blueLight);
            background: linear-gradient(#f4fcff, #ffffff);
            hr {
                background-color: var(--blueLight);
            }
        }

        &.gray-theme {
            padding-left: 0;
            border-color: var(--grayLight);
        }
    }

    .step-instructions {
        display: flex;
        flex-flow: row nowrap;
        a {
            color: var(--green) !important;
            text-decoration: underline;
        }
        .symbol {
            flex: 0 0 20%;
            padding-right: 2rem;
            display: none;
            .lock {
                width: 100%;
            }
            ${tabletMixin} {
                display: block;
            }

            .loyalty-badge {
                display: flex;
                justify-content: center;
                align-items: center;
                color: var(--greenLight);
            
                .loyalty-badge__icon {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    width: 120px;
                    height: 120px;
                    background: radial-gradient(#ffffff 60%, transparent 61%),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(16.36deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(32.73deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(49.09deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(65.45deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(81.81deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(98.18deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(114.54deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(130.90deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(147.27deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(164.2deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>");
                    /*background: radial-gradient(#ffffff 60%, transparent 61%),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(16.36deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(32.73deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(49.09deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(65.45deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(81.81deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(98.18deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(114.54deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(130.90deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(147.27deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(164.2deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>");*/
                    background-size: 100% 100%;
                    font-weight: bold;
                    font-size: 35px;
                    -webkit-transform: rotate(-15deg);
                    -moz-transform: rotate(-15deg);
                    transform: rotate(-15deg);
                    margin-right: 10px;
                }
            }
        }
        .cta {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            &:first-child {
                align-items: start;
                margin-bottom: 2rem;
            }
            &.cta--last{
                margin-top: 2rem;
            }
            .symbol-mobile {
                flex: 0 0 auto;
                padding-right: 1.375rem;
                .lock {
                    width: 3.125rem;
                }
                ${tabletMixin} {
                    display: none;
                }

                .loyalty-badge {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: var(--greenLight);
                
                    .loyalty-badge__icon {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    width: 50px;
                    height: 50px;
                    background: radial-gradient(#ffffff 60%, transparent 61%),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(16.36deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(32.73deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(49.09deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(65.45deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(81.81deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(98.18deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(114.54deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(130.90deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(147.27deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                                url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(164.2deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>");
                    /*background: radial-gradient(#ffffff 60%, transparent 61%),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(16.36deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(32.73deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(49.09deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(65.45deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(81.81deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(98.18deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(114.54deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(130.90deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(147.27deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>"),
                        url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-97 -3 256 262' width='256' stroke-dasharray='45, 35' stroke='rgb(0, 97, 127)' stroke-width='8' fill='white' style='transform:rotate(164.2deg);'><polygon points='48,16 32,0 16,16' /><polygon points='48,240 16,240 32,256' stroke-dashoffset='-32' /></svg>");*/
                    background-size: 100% 100%;
                    font-weight: bold;
                    font-size: 15px;
                    -webkit-transform: rotate(-15deg);
                    -moz-transform: rotate(-15deg);
                    transform: rotate(-15deg);
                    margin-right: 10px;
                    }
                }
            }
            .offer {
                color: var(--blue);
                flex: 0 0 4.5rem;
                font-size: 1.875rem;
                font-weight: 300;
                line-height: 1;
                ${tabletMixin} {
                    flex: 0 0 5.5rem;
                    font-size: 2.5rem;
                    padding-right: 2rem;
                }
                @media (max-width: 768px) {
                    padding-right: 15px;
                }
            }
            .small-note {
                display: block;
                margin-top: 12px;
                margin-left: 115px;

                @media (max-width: 768px) {
                    margin-left: 77px;
                }

                &.small-note--step-5 {
                    margin-left: 135px;

                    @media (max-width: 768px) {
                        margin-left: 92px;
                    }
                }
            }
        }
        .stack {
            hr {
                margin: 1rem 0;
            }
            &.centered {
                text-align: center;
                .cta {
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;
                }
            }
            ${tabletMixin} {
                flex: 1 1 80%;
            }
        }
    }

    .category-heading {
        display: flex;
        flex-flow: column wrap;
        position: relative;
        margin-bottom: 1rem;
        cursor: pointer;
        ${tabletMixin} {
            flex-flow: row wrap;
        }
        &:after {
            content: '';
            display: block;
            position: absolute;
            right: 0;
            border: .25rem solid var(--blueLight);
            border-right: 0;
            border-bottom: 0;
            height: 1rem;
            width: 1rem;
            margin: .5rem;
            transform: rotate(45deg);
            transform-origin: center;
            transition: transform .125s ease-in-out;
        }
        &.collapsed {
            margin-bottom: 0;
            &:after {
                transform: rotate(-135deg) translate(32.5%, 32.5%);
            }
            &+.table-wrapper {
                max-height: 0 !important;
            }
        }
        div {
            padding-right: 3rem;
            flex: 1 1 auto;
            &:first-child {
                padding-right: 1rem;
                flex: 0 0 auto;
            }
        }
        p {
            width: 100%;
        }
    }

    .product-promo{
        display: flex;
        flex-flow: column wrap;
        position: relative;
        margin-bottom: 1rem;
        cursor: pointer;
        color: var(--greenLight);
        ${tabletMixin} {
            flex-flow: row wrap;
        }
        &:after {
            content: '';
            display: block;
            position: absolute;
            right: 0;
            border: .25rem solid var(--grayLight);
            border-right: 0;
            border-bottom: 0;
            height: 1rem;
            width: 1rem;
            margin: .5rem;
            transform: rotate(-135deg);
            transform-origin: center;
            transition: transform .125s ease-in-out;
        }
        &.collapsed {
            margin-bottom: 0;
            &:after {
                transform: rotate(-225deg) translate(32.5%, 32.5%);
            }
        }
    }

    .product-promo__body {
        .product-promo__body--image {
            background-repeat: no-repeat;
            background-position: 50% 50%;
            background-size: contain;
            height: 152px;
            position: relative;
            max-width: 906px!important;
            max-height: 152px!important;
            background-image: url(https://www.mybayerplus.com/img/productpromotionalmodule/delaro-1up.jpg);
        }
        @media (max-width: 768px) {
            .product-promo__body--image {
                background-image: url(https://www.mybayerplus.com/img/productpromotionalmodule/delaro-3up.jpg);
                height: 100%;
                max-width: 290px!important;
                max-height: 200px!important;
                min-height: 200px;
                margin: auto;
            }
        }
    }

    .footer-nav {
        margin: 1rem 0 0;
        padding: 2rem;
        background-color: var(--greenLight);
        color: var(--white);
        text-align: center;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        ${tabletMixin} {
            flex-flow: row nowrap;
            >div {
                flex: 1 1 auto;
                text-align: left;
                font-weight: 500;
                &:last-child {
                    flex: 0 0 38%;
                    margin-left: 1rem;
                }
            }
        }
        .button {
            margin: 1rem 0;
            ${tabletMixin} {
                margin-top: 0;
                width: 100%;
            }
        }
        ${tabletMixin} {
            margin: 2rem;
            padding: 0;
            background-color: transparent;
        }
    }

    ${tabletMixin} {
        .step-3 {
            .footer-nav {
                &>div:last-child {
                    flex-basis: 38%;
                }
            }
        }
    }

    .app-container {
        padding: 20px 0;

        .bucket {
            h2,
            h3,
            h4 {
            margin-bottom: 0;
            }

            h2,
            h4 {
            margin-top: 0;
            }

            h4 {
            color: var(--white);
            font-size: 18px;
            font-weight: bold;
            }
        }
    }

    .content {
        .text-white {
            h4 {
            color: var(--white);
            }
        }

        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            margin-top: 0;
            margin-bottom: 0;
        }

        .select {
            margin-bottom: 0;
        }

        .step-summary {
            p {
            max-width: none;
            }
        }

        .inner {
            max-width: 1240px;
        }
    }

    a,
    a:hover,
    strong {
        color: inherit;
    }

    /* v3 styles */

    #content {
        input {
            border: 1px solid #66b512;
            padding: 12px;
            font-size: 16px;
            color: #10384f;
        }
        #app {
            // reset conflicting form styles
            label {
                font-size: 1rem;
                color: var(--blueDark);
                font-weight: 700;
                padding: 0;
                width: auto;
                float: none;
                clear: none;
            }
            .label {
                color: var(--blue) !important;
                font-size: 0.875rem !important;
                font-style: italic !important;
                font-weight: normal !important;
            }
            input {
                padding-bottom: calc(0.375em - 1px);
                padding-left: calc(0.625em - 1px);
                padding-right: calc(0.625em - 1px);
                padding-top: calc(0.375em - 1px);
            }
            input[type="radio"] + label {
                padding-left: 0 !important;
            }
            .select {
                padding: 0;
            }
            select {
                background: none;
                background-color: #fff;
                padding-bottom: calc(0.375em - 1px);
                padding-left: calc(0.625em - 1px);
                padding-right: 2.5em;
                padding-top: calc(0.375em - 1px);
                color: var(--blueDark);
                font-size: 1rem;
                border: none;
                -webkit-appearance: none;
                border-radius: 0;
                -moz-appearance: none;
                text-overflow: ellipsis;
            }
            
            // override hard rule styles
            hr {
                border-width: 0;
                margin: 2rem 0;
                height: 1px;

                &.with-heading {
                    margin-bottom: 1rem;
                }
            }
            .category-heading.collapsed + .table-wrapper {
                overflow: hidden;
            }

            .product-promo.collapsed + .product-promo__body {
                overflow: hidden;
                max-height: 0 !important;
            }
        }

        .branches {
            // reset conflicting text styles
            &.plaintext {
                a {
                    color: var(--greenLight);
                }
                p {
                    margin-bottom: 0;
                }
            }
        }
    }

    /**Modals */
    .ReactModal__Body--open {
        overflow: hidden;
    }
    .ReactModal__Overlay {
        align-items: center;
        background: rgba(10, 10, 10, 0.86) !important;
        display: flex;
        justify-content: center;
        opacity: 0;
        z-index: 999;
        transition: opacity 150ms ease-out;
        &.ReactModal__Overlay--after-open {
            opacity: 1;
        }
    }
    .ReactModal__Content {
        border-radius: 0 !important;
        color: var(--blueDark);
        height: auto;
        margin: 0 20px;
        width: 100%;
        padding: 0 !important;
        position: relative !important;
        inset: unset !important;

        ${tabletMixin} {
            margin: 0 auto;
            width: 640px;
        }

        header {
            border-bottom: 1px solid var(--borderGrayLight);
            display: flex;
            font-size: 1.5rem;
            font-weight: bold;
            line-height: 1;
            justify-content: flex-start;
            padding: 20px;
            position: relative;
        }

        .modal-body {
            border-bottom: 1px solid var(--borderGrayLight);
            padding: 20px;
            p {
                font-size: 1rem;
                margin: 0;
                padding: 0 10px;

                ${tabletMixin} {
                    font-size: 20px;
                    padding: 0 25px;
                }
            }
        }

        footer {
            align-items: center;
            display: flex;
            justify-content: center;
            padding: 20px;
            position: relative;
            .button {
                &:not(:last-child) {
                    margin-right: 10px;
                }
            }
        }

        .close-modal {
            background: transparent;
            border: 0;
            color: var(--white);
            cursor: pointer;
            font-size: 24px;
            line-height: 16px;
            margin: 0;
            padding: 0;
            right: 20px;
            top: 20px;
            position: fixed;
        }
    }
`;
